import EventEmitter2 from 'eventemitter2';

const ComponentsBus = new EventEmitter2();
ComponentsBus.setMaxListeners(10000);
const hookKeys = [];

const attachHooks = (component) => {
    hookKeys.forEach((hookKey) => {
        const hookKeyCamel = hookKey[0].toUpperCase() + hookKey.slice(1);
        const methodName = 'on' + hookKeyCamel;
        if (component[methodName]) {
            component[methodName] = component[methodName].bind(component);
            ComponentsBus.on(hookKey, component[methodName]);
        }
    });
};

export { attachHooks };

const detachHooks = (component) => {
    hookKeys.forEach((hookKey) => {
        const hookKeyCamel = hookKey[0].toUpperCase() + hookKey.slice(1);
        const methodName = 'on' + hookKeyCamel;
        if (component[methodName]) {
            ComponentsBus.off(hookKey, component[methodName]);
        }
    });
};

export { detachHooks };

const registerHook = (hookKey) => {
    hookKeys.push(hookKey);
};

export { registerHook };

const triggerHook = (hookKey, payload) => {
    const match = !!hookKeys.find((key) => key === hookKey);
    if (!match) {
        console.warn(`triggerHook: trying to trigger "${hookKey}" but hook has not been registered.`);
        return;
    }
    ComponentsBus.emit(hookKey, payload);
};

export { triggerHook };
